<template>
	<StandardModal data-context="Preset Premium Offramp Confirm" @modal-close="close">
		<template #title>
			<h3 class="heading-5">Are you sure?</h3>
		</template>
		<template #content
			>By continuing, you will no longer have access to invest in the {{ props.offeringName }}. You can always
			reach out to our Investor Relations team to regain access.
		</template>
		<template #button-section>
			<BaseButtonGroup>
				<template #secondary>
					<BaseButton class="button button-outline" @click="close"> No, never mind </BaseButton>
				</template>
				<template #primary>
					<BaseButton
						:classes="'button button-default'"
						:is-working="isWorking"
						data-test="change-to-standard"
						@click="exitPresetInvestmentFlow"
					>
						Yes, continue
					</BaseButton>
				</template>
			</BaseButtonGroup>
		</template>
	</StandardModal>
</template>
<script setup lang="ts">
import { changeToStandardFlow } from '@api/checkout';
import { ref } from 'vue';
import StandardModal from '@components/modals/standard-modal.vue';
import { useRouter } from 'vue-router';

interface Props {
	offeringName: string;
}

interface Emits {
	(e: 'modal-close'): void;
}

const props = defineProps<Props>();

const emits = defineEmits<Emits>();

const router = useRouter();

const isWorking = ref(false);

function close(): void {
	emits('modal-close');
}

async function exitPresetInvestmentFlow(): Promise<void> {
	isWorking.value = true;
	try {
		await changeToStandardFlow();
		close();
		await router.push({ name: 'checkout-resume' });
	} catch (error) {
	} finally {
		isWorking.value = false;
	}
}
</script>
